import React, { useEffect, useState } from 'react';
import { Card, Table, Divider } from '@scuf/common';
import { useTranslation } from 'react-i18next';
import { notificationAtom } from 'resources';
import { EventoTransicao } from 'models/rmamanufatura/detailsRma';
import { formatDateDiaMesAnoHoraMinuto } from 'helpers';
import { useSetRecoilState } from 'recoil';
import { getEventosById } from 'resources/api/repaircenter_api/administrative';

interface ControleDeFluxoProps {
    rmaId: number;
}

const FlowRmaControl: React.FC<ControleDeFluxoProps> = ({ rmaId }) => {
    const { t } = useTranslation([
        'repaircenter',
        'common',
        'rmamanufatura'
    ]);

    const [loading, setLoading] = useState(false);
    const [eventos, setEventos] = useState<EventoTransicao[]>([]);

    const setNotification = useSetRecoilState(notificationAtom);

    useEffect(() => {
        const carregarEventos = async () => {
            if (!rmaId) {
                setEventos([]);
                return;
            }

            setLoading(true);

            try {
                const result = await getEventosById(rmaId);
                setEventos(result?.data ?? []);
            } catch (error) {
                setEventos([]);
                setNotification(old => ({
                    ...old,
                    message: t('common:errors.ErroEvento')
                }));
            } finally {
                setLoading(false);
            }
        };

        carregarEventos();
    }, [rmaId, setNotification, t]);

    function formatFirstLetterUpper(str?: string | null) {
        if (!str) return '';

        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    return (
        <Card>
            <Card.Content>
                <h2>
                    {t('rmamanufatura:translation.FlowControl')}
                </h2>

                <Divider />

                <Table loading={loading}>
                    <Table.Header>
                        <Table.HeaderCell
                            content={t('common:translation.Status')}
                        />
                        <Table.HeaderCell content="SSO ID" />

                        <Table.HeaderCell
                            content={t(
                                'rmamanufatura:translation.Situation'
                            )}
                        />

                        <Table.HeaderCell
                            content={t(
                                'rmamanufatura:translation.Observation'
                            )}
                        />

                        <Table.HeaderCell
                            content={t('common:translation.DateBR')}
                        />
                    </Table.Header>

                    <Table.Body>
                        {eventos.map((transicao: EventoTransicao) => (
                            <Table.Row key={transicao.id}>
                                <Table.Cell>
                                    {transicao.status}
                                </Table.Cell>

                                <Table.Cell>
                                    {transicao.ssoId}
                                </Table.Cell>

                                <Table.Cell>
                                    {formatFirstLetterUpper(
                                        transicao.situacao
                                    )}
                                </Table.Cell>

                                <Table.Cell>
                                    {transicao.observacao ?? '-'}
                                </Table.Cell>

                                <Table.Cell>
                                    {formatDateDiaMesAnoHoraMinuto(
                                        transicao.updatedAt.toLocaleString()
                                    )}
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>

                {eventos.length === 0 && !loading && (
                    <div
                        style={{
                            marginTop: 16,
                            color: '#888'
                        }}
                    >
                        {t(
                            'rmamanufatura:translation.NoTransitionsFound'
                        )}
                    </div>
                )}
            </Card.Content>
        </Card>
    );
};

export default FlowRmaControl;